import { Button, Card, Skeleton } from 'antd'
import { FC, useState } from 'react'
import fabImage from '../images/facebook.png'
import FbIntergrationModal from './FbIntergrationModal'
import { TIntegrationItem } from '../types'

const FbIntegrationCard: FC<{
 onDisconnect?: (id: any, b?: boolean) => void
 isLoading?: boolean
 onConnect?: () => void
 data?: TIntegrationItem[]
 //  type?: IntegrationImgType
}> = ({ onConnect, data, isLoading, onDisconnect }) => {
 const [showModal, setShowModal] = useState(false)
 return (
  <>
   <Card className="int-card-new">
    {isLoading ? (
     <Skeleton />
    ) : (
     <>
      <div className="int-card-new-header">
       <img className="int-card-new-img" src={fabImage} alt="" />
      </div>
      {data && data?.length > 0 ? (
       <div
        className="w-100"
        style={{ display: 'flex', flexDirection: 'column', rowGap: '4px' }}
       >
        {data.slice(0, 2).map((itm, indx) => (
         <div
          className="w-100"
          style={{
           display: 'flex',
           justifyContent: 'space-between',
           alignItems: 'center',
           border: '1px solid #aaa',
           padding: '2px 6px',
           borderRadius: '4px',
          }}
          key={indx}
         >
          {itm.page_name}
          <Button
           onClick={() => onDisconnect?.(itm.page_id)}
           icon={<i className="far fa-times-circle" />}
           type="link"
          />
         </div>
        ))}
        <Button
         className="mt-2"
         onClick={() => setShowModal(true)}
         shape="round"
         type="link"
        >
         View All
        </Button>
       </div>
      ) : (
       <div className="text-center">
        <div>
         <p>
          Easily link your Facebook Lead Ads to AgentRoof CRM and capture leads
          instantly with just a few clicks.
         </p>
        </div>
        <Button onClick={() => setShowModal(true)} shape="round" type="primary">
         Connect Now
        </Button>
       </div>
      )}
     </>
    )}
   </Card>
   {showModal && (
    <FbIntergrationModal
     intItems={data}
     //  setIntItems={setIntItems}
     onCancel={() => setShowModal(false)}
     show={showModal}
    />
   )}
  </>
 )
}

export default FbIntegrationCard
